import { render, staticRenderFns } from "./dropdownField.vue?vue&type=template&id=2b64755c&scoped=true&"
import script from "./dropdownField.vue?vue&type=script&lang=js&"
export * from "./dropdownField.vue?vue&type=script&lang=js&"
import style0 from "./dropdownField.vue?vue&type=style&index=0&id=2b64755c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b64755c",
  null
  
)

export default component.exports